import { Box, Button, Checkbox, Chip, Dialog, DialogContent, DialogTitle, Divider, Drawer, Grid, info, List, ListItem, ListItemButton, ListItemText, MenuItem, Paper, RadioGroup, Select, Stack, Typography, useMediaQuery } from '@mui/material'
import React, { useState, useEffect } from 'react'
import { amber, darkGrey, headingBlue, lightGrey, maroon, mediumGrey, pureWhite, red } from '../../../assets/colors'
import { assignDistrictToHead, assignDistrictToStateHead, createHeadAcc, getHeadlessDistricts, getHeadlessStates, getIndianStates, getMemCardStatus, getMemCardStatusDB, getMemberStateHeadDetails, getMembersDistrictHeadDetails, getStateHeadLessStates, getStateHeadlessDistricts, getWORKerObligationAndAccountDetails, isAccountCreated, updateWORKerProfile, isRegistrationForm } from '../../../backend/backendApis'
import HttpService from '../../../backend/requestApis'
import { useNavigate } from 'react-router-dom'
import { buttonStyle } from '../../../utils/commonCSS'
import Memcard from '../../membershipCard/memcard'
import UpdateWORKerDetails from '../UpdateWORKersDetails/updateWORKerDetails'
import Loader from '../../Loader'
import CustomDropDown from '../../CustomDropDown'
import { ArrowBack } from '@mui/icons-material'
import CustomTextField from '../../CustomTextField'
import { validateEmail } from '../../../utils/validations'
import ConfigWORKerContrFields from '../contributionFields/ConfigWORKerContrFields'
import ConfirmationDialogBox from '../../confirmationDialogBox'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { workerTypes, WORKerTypesList } from '../../../utils/constants'
import CustomRadioButton from '../../CustomRadioButtons'
import RegistrationInviteDetails from '../../RegistrationHub/RegistrationInviteDetails'

const WORKerCategoryList = [
    { label: 'Committed WORKers', value: 'committed', name: 'committed' },
    { label: 'Supported WORKer', value: 'nonCommitted', name: 'nonCommitted' }
]

const getCategoryValue = (data) => {
    const cat = data?.WORKerCategory || data?.WORKerCateogary || data?.workerCategory || data?.workerCateogary;
    if (!cat || typeof cat !== 'string') return '';
    const cleaned = cat.trim().toLowerCase().replace(/[^a-z]/g, '');
    if (cleaned === 'committed') {
        return 'committed';
    }
    if (cleaned === 'noncommitted' || cleaned === 'noncommited' || cleaned === 'uncommitted') {
        return 'nonCommitted';
    }
    return '';
};

const WORKerSettingDialog = (props) => {

    const isMobile = useMediaQuery("(max-width:600px)");

    const navigate = useNavigate()

    const [selectedModule, setSelectedModule] = useState('')
    const [closeDialog, setCloseDialog] = useState(false)

    const [isStateHead, setIsStateHead] = useState(false)
    const [isDistrictHead, setIsDistrictHead] = useState(null)
    const [stateHeadDistricts, setStateHeadDistricts] = useState([])
    const [addStateClickedStatus, setAddStateClickedStatus] = useState(false)
    const [stateHeadlessStates, setStateHeadlessStates] = useState([])
    const [selectedStateHeadlessState, setSelectedStateHeadlessState] = useState('State')
    const [stateHeadlessDistricts, setStateHeadlessDistricts] = useState([])
    const [selectedStateHeadlessDistrict, setSelectedStateHeadlessDistrict] = useState('District')
    const [selectedStatesToAdd, setSelectedStatesToAdd] = useState([])
    const [assignToStateHeadError, setAssignToStateHeadError] = useState(null)
    const [updateStateHeadDistricts, setUpdateStateHeadDistricts] = useState(false)

    const [addDistrictClickedStatus, setAddDistrictClickedStatus] = useState(false)
    const [districtHeadDistricts, setDistrictHeadDistricts] = useState([])
    const [selectedDistrictsToAdd, setSelectedDistrictsToAdd] = useState([])
    const [updateDistrictHeadDistricts, setUpdateDistrictHeadDistricts] = useState(false)
    const [districtHeadlessStates, setDistrictHeadlessStates] = useState([])
    const [selectedDistrictHeadlessState, setSelectedDistrictHeadlessState] = useState('State')
    const [districtHeadlessDistricts, setDistrictHeadlessDistricts] = useState([])
    const [selectedDistrictHeadlessDistrict, setSelectedDistrictHeadlessDistrict] = useState('District')


    const [memcardSection, setMemCardSection] = useState(false)
    const [memCardStatus, setMemCardStatus] = useState(null)
    const [updateWORKerDetailsDialogStatus, setUpdateWORKerDetailsDialogStatus] = useState(false)
    const [memcardDialogStatus, setMemCardDialogStatus] = useState(false)
    const [chapterCode, setChapterCode] = useState(null)
    const [name, setName] = useState(null)
    const [id, setId] = useState(null)
    const [photoStatus, setPhotoStatus] = useState(null)
    const [gender, setGender] = useState(null)
    const [obligation, setObligation] = useState(null)

    const [isAccountExists, setIsAccountExists] = useState(false)
    const [enteredEmail, setEnteredEmail] = useState('')
    const [refreshAccStatus, setRefreshAccStatus] = useState(false)
    const [mailError, setMailError] = useState('')

    const [loader, setLoader] = useState(false)

    const [leaderDialogStatus, setLeaderDialogStatus] = React.useState(false);
    const [confirmationMessage, setConfirmationMessage] = React.useState('');
    const [leaderContactNumber, setLeaderContactNumber] = React.useState(null);
    const [leaderIsLeader, setLeaderIsLeader] = React.useState(null);
    const [isNoActionDialog, setIsNoActionDialog] = React.useState(false);
    const [operation, setOperation] = React.useState('default');

    const [selectedWorkerType, setSelectedWorkerType] = useState(props?.data?.WORKerType);
    const [selectedWORKerTypeDetails, setSelectedWORKerTypeDetails] = useState({})
    const [selectedWORKerCategory, setSelectedWORKerCategory] = useState(getCategoryValue(props?.data));
    const [refreshCardSec, setRefreshCardSec] = useState(false)
    const [isRegFormExists, setIsRegFormExists] = useState(false)
    const [regFormId, setRegFormId] = useState(null)
    const [regFormData, setRegFormData] = useState(null)
    const [regFormDialogStatus, setRegFormDialogStatus] = useState(false)

    const handleAddDistrictToAdd = (array) => {
        var uniqueArray = array.filter(
            (obj, index, self) => index === self.findIndex((ele) => ele.district === obj.district && ele.state === obj.state)
        )
        setSelectedStatesToAdd(uniqueArray)
    }

    const deleteDistrictFromAddition = (district) => {
        var array = selectedStatesToAdd
        var filteredArray = array.filter((obj) => obj.district != district.district)
        setSelectedStatesToAdd(filteredArray)
    }

    const updateLeaderDialogStatus = (
        status,
        msg,
        contactNumber,
        isLeader,
        noActionDialog,
        refresh = false
    ) => {
        setLeaderDialogStatus(status);
        setConfirmationMessage(msg);
        setLeaderContactNumber(contactNumber);
        setLeaderIsLeader(isLeader);
        setIsNoActionDialog(noActionDialog);

        if (refresh) {
            // if you have a prop to refresh table or settings, call it here
            props.refreshTableApi && props.refreshTableApi();
        }
    };


    const handleAssignDistrictsToStateHead = () => {
        try {
            setLoader(true)
            if (selectedStatesToAdd.length === 0) {
                setAssignToStateHeadError('Choose atleast one district.')
                setLoader(false)
            } else {
                let options = {
                    url: assignDistrictToStateHead,
                    method: 'POST',
                    payload: {
                        contactNumber: props?.data?.contactNumber,
                        chapters: selectedStatesToAdd
                    },
                    headers: {
                        headers: {
                            Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
                        }
                    }
                }
                HttpService(options).then((resp) => {
                    console.log("successfully assigned district to state head.")
                    setLoader(false)
                    setAddStateClickedStatus(false)
                    setUpdateStateHeadDistricts(!updateStateHeadDistricts)
                }).catch(err => {
                    setLoader(false)
                    if (err?.status === 403) {
                        localStorage.clear();
                        // setLoadingTableData(false);
                        navigate("/Login");
                    } else {
                        console.log("Error in assigning districts to state head.", err)
                    }
                })
            }

        } catch (err) {
            setLoader(false)
            console.log("Errorin assigning districts to state head: ", err)
        }
    }

    const handleAddDistrictToHead = (array) => {
        var uniqueArray = array.filter(
            (obj, index, self) => index === self.findIndex((ele) => ele.district === obj.district && ele.state === obj.state)
        )
        setSelectedDistrictsToAdd(uniqueArray)
    }

    const deleteHeadDistrictFromAddition = (district) => {
        var array = selectedDistrictsToAdd
        var filteredArray = array.filter((obj) => obj.district != district.district)
        setSelectedDistrictsToAdd(filteredArray)
    }

    const handleAssignDistrictToDistrictHead = () => {
        try {
            setLoader(true)
            if (selectedDistrictsToAdd.length === 0) {
                setLoader(false)
            } else {
                let options = {
                    url: assignDistrictToHead,
                    method: 'POST',
                    payload: {
                        contactNumber: props?.data?.contactNumber,
                        chapters: selectedDistrictsToAdd
                    },
                    headers: {
                        headers: {
                            Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
                        }
                    }
                }
                HttpService(options).then((resp) => {
                    console.log("successfully assigned district to district head.")
                    setLoader(false)
                    setAddDistrictClickedStatus(false)
                    setUpdateDistrictHeadDistricts(!updateDistrictHeadDistricts)
                }).catch(err => {
                    setLoader(false)
                    if (err?.status === 403) {
                        localStorage.clear();
                        // setLoadingTableData(false);
                        navigate("/Login");
                    } else {
                        console.log("Error in assigning districts to district head.", err)
                    }
                })
            }

        } catch (err) {
            setLoader(false)
            console.log("Errorin assigning districts to district head: ", err)
        }
    }

    const handleCreateAcc = () => {
        try {
            setLoader(true)

            let emailValidation = validateEmail(enteredEmail, 'email')

            if (emailValidation === '') {
                let options = {
                    url: createHeadAcc,
                    method: 'POST',
                    payload: {
                        contactNumber: props?.data?.contactNumber,
                        email: enteredEmail
                    },
                    headers: {
                        headers: {
                            Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
                        }
                    }
                }
                HttpService(options).then((resp) => {
                    console.log("successfully Created head acc.")
                    setLoader(false)
                    setRefreshAccStatus(!refreshAccStatus)
                }).catch(err => {
                    setLoader(false)
                    if (err?.status === 403) {
                        localStorage.clear();
                        // setLoadingTableData(false);
                        navigate("/Login");
                    } else {
                        console.log("Error in creating head acc.", err)
                    }
                })
            } else {
                setMailError(emailValidation)
                setLoader(false)
            }

        } catch (err) {
            console.log("Error in creating head acc.", err)
            setLoader(false)
        }
    }

    const updateSelectWORKerType = (value) => {
        setSelectedWorkerType(() => value)
    }

    const updateSelectWORKerCategory = (value) => {
        setSelectedWORKerCategory(() => value)
    }

    const updateProfileType = () => {
        setLoader(true)

        let formattedCategory = undefined;
        if (selectedWORKerCategory) {
            const cleaned = String(selectedWORKerCategory).trim().toLowerCase().replace(/[^a-z]/g, '');
            if (cleaned === 'committed') {
                formattedCategory = 'committed';
            } else if (cleaned === 'noncommitted' || cleaned === 'noncommited' || cleaned === 'uncommitted') {
                formattedCategory = 'nonCommitted';
            }
        }

        let options = {
            url: updateWORKerProfile,
            method: 'POST',
            payload: {
                contactNumber: props?.data?.contactNumber,
                workerType: selectedWorkerType,
                workerCategory: formattedCategory
            },
            headers: {
                headers: {
                    Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
                }
            },
        }

        HttpService(options)
            .then((resp) => {
                console.log("Worker profile updated", resp)
                setLoader(false)
                props?.setWORKerSettingDialogStatus(false, true)
            })
            .catch((err) => {
                setLoader(false)
                if (err?.status === 403) {
                    localStorage.clear();
                    // setLoadingTableData(false);
                    navigate("/Login");
                } else {
                    console.log("Error updating profile", err)
                }
            })
    }


    useEffect(() => {
        setIsDistrictHead(props?.data?.isDistrictHead)
        setIsStateHead(props?.data?.isStateHead)
        setStateHeadDistricts([])
        setAddStateClickedStatus(false)
        setStateHeadlessStates([])
        setSelectedStateHeadlessState('State')
        setStateHeadlessDistricts([])
        setSelectedStateHeadlessDistrict('District')
        setSelectedStatesToAdd([])
        setAssignToStateHeadError('')
        setUpdateStateHeadDistricts(!updateStateHeadDistricts)

        setDistrictHeadDistricts([])
        setAddDistrictClickedStatus(false)
        setDistrictHeadlessStates([])
        setSelectedDistrictHeadlessState('State')
        setDistrictHeadlessDistricts([])
        setSelectedDistrictHeadlessDistrict('District')
        setSelectedDistrictsToAdd([])
        setUpdateDistrictHeadDistricts(!updateDistrictHeadDistricts)

        setIsAccountExists(false)
        setEnteredEmail('')
        setRefreshAccStatus(false)
        setMailError('')

        setSelectedWorkerType(props?.data?.WORKerType)
        setSelectedWORKerTypeDetails({})
        setSelectedWORKerCategory(getCategoryValue(props?.data))
        setIsRegFormExists(false)
        setRegFormId(null)
        setRegFormData(null)
        setRegFormDialogStatus(false)
    }, [selectedModule])

    useEffect(() => {
        setSelectedModule((localStorage.getItem('designation') === 'admin' || localStorage.getItem('isStateHead') || localStorage.getItem('isDistrictHead')) ? 'profile' : 'membershipCard')
        setIsDistrictHead(props?.data?.isDistrictHead)
        setIsStateHead(props?.data?.isStateHead)
        setStateHeadDistricts([])
        setAddStateClickedStatus(false)
        setStateHeadlessStates([])
        setSelectedStateHeadlessState('State')
        setStateHeadlessDistricts([])
        setSelectedStateHeadlessDistrict('District')
        setSelectedStatesToAdd([])
        setAssignToStateHeadError('')
        setUpdateStateHeadDistricts(!updateStateHeadDistricts)

        setDistrictHeadDistricts([])
        setAddDistrictClickedStatus(false)
        setDistrictHeadlessStates([])
        setSelectedDistrictHeadlessState('State')
        setDistrictHeadlessDistricts([])
        setSelectedDistrictHeadlessDistrict('District')
        setSelectedDistrictsToAdd([])
        setUpdateDistrictHeadDistricts(!updateDistrictHeadDistricts)

        setIsAccountExists(false)
        setEnteredEmail('')
        setRefreshAccStatus(false)
        setMailError('')
        setIsRegFormExists(false)
        setRegFormId(null)
        setRegFormData(null)
        setRegFormDialogStatus(false)
    }, [props.WORKerSettingDialogStatus])

    useEffect(() => {
        try {
            if (selectedModule === 'stateHead' && isStateHead === true) {
                setLoader(true)
                let options = {
                    url: getMemberStateHeadDetails,
                    method: 'GET',
                    params: {
                        contactNumber: props?.data?.contactNumber,
                        gender: props?.data?.gender
                    },
                    headers: {
                        Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
                    }
                }
                HttpService(options).then(resp => {
                    setStateHeadDistricts(resp?.data?.data)
                    setLoader(false)
                }).catch(err => {
                    setLoader(false)
                    if (err?.status === 403) {
                        localStorage.clear();
                        // setLoadingTableData(false);
                        navigate("/Login");
                    } else {
                        console.log('Error in fetching member state head details: ', err)
                    }
                })
            }
        } catch (err) {
            setLoader(false)
            console.log("Error in fetching WORKer's statehead details: ", err)
        }
    }, [selectedModule, isStateHead, updateStateHeadDistricts])

    useEffect(() => {
        try {
            if (addStateClickedStatus) {
                setLoader(true)
                let options = {
                    url: getStateHeadLessStates,
                    method: 'GET',
                    params: {
                        gender: props?.data?.gender
                    },
                    headers: {
                        Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
                    }
                }
                HttpService(options).then(resp => {
                    setStateHeadlessStates(resp?.data?.data)
                    setLoader(false)

                }).catch(err => {
                    setLoader(false)
                    if (err?.status === 403) {
                        localStorage.clear();
                        // setLoadingTableData(false);
                        navigate("/Login");
                    } else {
                        console.log('Error in fetching the stateHeadless states.')
                    }
                })
            }
        } catch (err) {
            console.log("Error in fetching the stateHeadless States: ", err)
            setLoader(false)
        }
    }, [addStateClickedStatus])

    useEffect(() => {
        try {
            setLoader(true)
            let options = {
                url: getStateHeadlessDistricts,
                method: 'GET',
                params: {
                    gender: props?.data?.gender,
                    state: selectedStateHeadlessState
                },
                headers: {
                    Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
                }
            }
            HttpService(options).then(resp => {
                setStateHeadlessDistricts(resp?.data?.data)
                setLoader(false)
            }).catch(err => {
                setLoader(false)
                if (err?.status === 403) {
                    localStorage.clear();
                    // setLoadingTableData(false);
                    navigate("/Login");
                } else {
                    console.log("Error in fetching stateHeadless Districts: ", err)
                }
            })
        } catch (err) {
            console.log("Error in fetching the stateHeadlessDistricts: ", err)
            setLoader(false)
        }
    }, [selectedStateHeadlessState])

    useEffect(() => {
        try {
            if (selectedModule === 'districtHead' && isDistrictHead === true) {
                setLoader(true)
                let options = {
                    url: getMembersDistrictHeadDetails,
                    method: 'GET',
                    params: {
                        contactNumber: props?.data?.contactNumber,
                        gender: props?.data?.gender
                    },
                    headers: {
                        Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
                    }
                }
                HttpService(options).then(resp => {
                    setDistrictHeadDistricts(resp?.data?.data)
                    setLoader(false)
                }).catch(err => {
                    setLoader(false)
                    if (err?.status === 403) {
                        localStorage.clear();
                        // setLoadingTableData(false);
                        navigate("/Login");
                    } else {
                        console.log('Error in fetching member district head details: ', err)
                    }
                })
            }
        } catch (err) {
            setLoader(false)
            console.log("Error in fetching WORKer's district head details: ", err)
        }
    }, [selectedModule, isDistrictHead, updateDistrictHeadDistricts])

    useEffect(() => {
        try {
            if (addDistrictClickedStatus) {
                setLoader(true)
                let options = {
                    url: getHeadlessStates,
                    method: 'GET',
                    params: {
                        gender: props?.data?.gender
                    },
                    headers: {
                        Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
                    }
                }
                HttpService(options).then((resp) => {
                    setDistrictHeadlessStates(resp?.data?.data)
                    setLoader(false)
                }).catch(err => {
                    setLoader(false)
                    if (err?.status === 403) {
                        localStorage.clear();
                        // setLoadingTableData(false);
                        navigate("/Login");
                    } else {
                        console.log('Error in fetching the districtHeadless states.')
                    }
                })
            }

        } catch (err) {
            console.log("Error in fetching headless districts: ", err)
            setLoader(false)
        }
    }, [addDistrictClickedStatus])

    useEffect(() => {
        try {
            setLoader(true)
            let options = {
                url: getHeadlessDistricts,
                method: 'GET',
                params: {
                    gender: props?.data?.gender,
                    state: selectedDistrictHeadlessState
                },
                headers: {
                    Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
                }
            }
            HttpService(options).then((resp) => {
                setDistrictHeadlessDistricts(resp?.data?.data)
                setLoader(false)
            }).catch(err => {
                setLoader(false)
                if (err?.status === 403) {
                    localStorage.clear();
                    // setLoadingTableData(false);
                    navigate("/Login");
                } else {
                    console.log("Error in fetching districtHeadless Districts: ", err)
                }
            })

        } catch (err) {
            console.log("Error in fetching the districtHeadlessDistricts: ", err)
            setLoader(false)
        }
    }, [selectedDistrictHeadlessState])

    useEffect(() => {
        try {
            if (selectedModule === 'account') {
                setLoader(true)
                let options = {
                    url: isAccountCreated,
                    method: 'GET',
                    params: {
                        contactNumber: props?.data?.contactNumber,
                    },
                    headers: {
                        Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
                    }
                }
                HttpService(options).then(resp => {
                    setIsAccountExists(() => resp?.data?.data?.accExist)
                    setLoader(false)
                }).catch(err => {
                    setLoader(false)
                    if (err?.status === 403) {
                        localStorage.clear();
                        // setLoadingTableData(false);
                        navigate("/Login");
                    } else {
                        console.log("Error in fetching acc status: ", err)
                    }

                })
            }

        } catch (err) {
            console.log('Error in fetching the a/c status: ', err)
        }
    }, [selectedModule, refreshAccStatus])

    useEffect(() => {
        try {
            if (selectedModule === 'membershipCard' && props.WORKerSettingDialogStatus) {
                setLoader(true)
                let options = {
                    url: getMemCardStatusDB,
                    method: 'GET',
                    params: {
                        contactNumber: props?.data?.contactNumber
                    },
                    headers: {
                        Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
                    }
                }
                HttpService(options).then(resp => {
                    setMemCardStatus(resp?.data?.data?.isMemCardGenerated)
                    if (resp?.data?.data?.isMemCardGenerated) {
                        setName(resp?.data?.data?.name)
                        setChapterCode(resp?.data?.data?.chapterCode)
                        setId(resp?.data?.data?.id)
                        setPhotoStatus(resp?.data?.data?.photoStatus)
                        setObligation(resp?.data?.data?.obligation)
                    } else {
                        setGender(resp?.data?.data?.gender)
                        setId(resp?.data?.data?.id)
                        setChapterCode(resp?.data?.data?.chapterCode)
                        setObligation(resp?.data?.data?.obligation)
                    }
                    setLoader(false)
                }).catch(err => {
                    setLoader(false)
                    if (err?.status === 403) {
                        localStorage.clear();
                        // setLoadingTableData(false);
                        navigate("/Login");
                    } else {
                        console.log('Error in getting mem card Status: ', err)
                    }

                })

                let formOptions = {
                    url: `${isRegistrationForm}/${props?.data?.contactNumber}`,
                    method: 'GET',
                    headers: {
                        Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
                    }
                }
                HttpService(formOptions).then(resp => {
                    setIsRegFormExists(resp?.data?.data?.exists ? true : false)
                    setRegFormId(resp?.data?.data?._id)
                    if (resp?.data?.data) {
                        setRegFormData({
                            _id: resp.data.data._id,
                            name: resp.data.data.name,
                            contactNumber: resp.data.data.contactNumber,
                            status: resp.data.data.status,
                            generatedBy: resp.data.data.generatedBy,
                            generatedByCN: resp.data.data.generatedByCN,
                            reviewedBy: resp.data.data.reviewedBy,
                            reviewedByCN: resp.data.data.reviewedByCN
                        })
                    }
                }).catch(err => {
                    console.log('Error in getting registration form status: ', err)
                })
            }
        } catch (err) {
            setLoader(false)
            console.log('Error in checking mem card status: ', err)
        }
    }, [selectedModule, refreshCardSec, props.WORKerSettingDialogStatus])

    useEffect(() => {
        if (selectedModule === 'profile' && props.WORKerSettingDialogStatus) {
            if (props?.data?.WORKerType) {
                let details = WORKerTypesList.find(ele => ele.value === props?.data?.WORKerType)
                setSelectedWorkerType(() => props?.data?.WORKerType)
                setSelectedWORKerTypeDetails(() => details)
            } else {
                setSelectedWorkerType(() => null)
                // setSelectedWORKerTypeDetails(() => {})
            }
            setSelectedWORKerCategory(getCategoryValue(props?.data))
        }

    }, [props.WORKerSettingDialogStatus, selectedModule, props?.data])

    var titleStyle = {
        backgroundColor: headingBlue,
        color: 'white',
        fontSize: '1rem',
        display: "flex",
        alignItems: 'center',
        height: "1.8rem",
        padding: "0.4rem 0rem 0.4rem 1rem"
    }
    return (
        <>
            <Dialog maxWidth='md' fullWidth open={props.WORKerSettingDialogStatus} onClose={() => {
                setCloseDialog(!closeDialog)
                props.setWORKerSettingDialogStatus(false, true)
            }}>
                <DialogTitle style={{ backgroundColor: headingBlue, color: 'white', fontSize: '1rem', }}>
                    WORKer Details
                </DialogTitle>
                <DialogContent style={{ padding: '0rem', height: '50vh' }}>
                    <Grid container spacing={1} direction={isMobile ? 'column' : 'row'} style={{ padding: '0rem 0rem 0rem 0.1rem' }}>
                        <Grid item xs={2.5} sm={2.5} style={{}}>
                            <List style={{
                                padding: '0.2rem 0.1rem 0.2rem 0.2rem',
                                display: 'flex',
                                flexDirection: isMobile ? 'row' : 'column',
                                flexWrap: 'wrap',
                                gap: 1
                            }}>
                                {<ListItem style={{ padding: '0rem', width: 'auto' }}>

                                    <ListItemButton style={{
                                        padding: '0.2rem 0.1rem 0.2rem 0.5rem',
                                        backgroundColor: selectedModule === 'profile' ? mediumGrey : pureWhite
                                    }}
                                        onClick={() => { setSelectedModule('profile') }}
                                    > Profile
                                    </ListItemButton>
                                </ListItem>}
                                {(localStorage.getItem('designation') === 'admin') &&
                                    <ListItem style={{ padding: '0rem', width: 'auto' }}>

                                        <ListItemButton style={{
                                            padding: '0.2rem 0.1rem 0.2rem 0.5rem',
                                            backgroundColor: selectedModule === 'stateHead' ? mediumGrey : pureWhite
                                        }}
                                            onClick={() => { setSelectedModule('stateHead') }}
                                        > State Head
                                        </ListItemButton>
                                    </ListItem>}
                                {(localStorage.getItem('designation') === 'admin' || localStorage.getItem('isStateHead')) &&
                                    <ListItem style={{ padding: '0rem', width: 'auto' }}>
                                        <ListItemButton style={{
                                            padding: '0.2rem 0.1rem 0.2rem 0.5rem',
                                            backgroundColor: selectedModule === 'districtHead' ? mediumGrey : pureWhite
                                        }}
                                            onClick={() => { setSelectedModule('districtHead') }}

                                        > District Head
                                        </ListItemButton>
                                    </ListItem>}
                                <ListItem style={{ padding: '0rem', width: 'auto' }}>
                                    <ListItemButton style={{
                                        padding: '0.2rem 0.1rem 0.2rem 0.5rem',
                                        backgroundColor: selectedModule === 'membershipCard' ? mediumGrey : pureWhite
                                    }}
                                        onClick={() => { setSelectedModule('membershipCard') }}
                                    > Membership Card and Form
                                    </ListItemButton>
                                </ListItem>

                                <ListItem style={{ padding: '0rem', width: 'auto' }}>
                                    <ListItemButton style={{
                                        padding: '0.2rem 0.1rem 0.2rem 0.5rem',
                                        backgroundColor: selectedModule === 'contrAreas' ? mediumGrey : pureWhite
                                    }}
                                        onClick={() => { setSelectedModule('contrAreas') }}
                                    > Volunteering Domains
                                    </ListItemButton>
                                </ListItem>
                                {<ListItem style={{ padding: '0rem', width: 'auto' }}>
                                    <ListItemButton style={{
                                        padding: '0.2rem 0.1rem 0.2rem 0.5rem',
                                        backgroundColor: selectedModule === 'account' ? mediumGrey : pureWhite
                                    }}
                                        onClick={() => { setSelectedModule('account') }}
                                    > Account
                                    </ListItemButton>
                                </ListItem>}

                            </List>

                        </Grid>
                        <Grid item xs={9} sm={9} style={{ height: '50vh', borderLeft: '1px solid #D3D3D3', padding: '0rem 0rem 0.5rem 0.75rem' }}>
                            <Grid container spacing={1} style={{ marginTop: '0.8rem', color: maroon }}>
                                <Grid item xs={3} sm={3}>
                                    {props.data.name}
                                </Grid>
                                <Grid item xs={3} sm={3}>
                                    {props.data.contactNumber}
                                </Grid>
                                <Grid item xs={3} sm={3}>
                                    {props.data.district}
                                </Grid>
                                <Grid item xs={3} sm={3}>
                                    {props.data.chapter}
                                </Grid>

                            </Grid>

                            {(selectedModule === 'profile' || selectedModule === 'Profile') &&
                                <Box sx={{
                                    maxHeight: { xs: 'calc(50vh - 55px)', sm: 'calc(50vh - 40px)' },
                                    overflowY: 'auto',
                                    pr: { xs: 0.5, sm: 1 },
                                    scrollbarWidth: 'none',
                                    '&::-webkit-scrollbar': { display: 'none' }
                                }}>
                                    {loader && <Loader></Loader>}

                                    {/* WORKer Classification Cards (Side by side on desktop, stacked on mobile) */}
                                    <Grid container spacing={1.5} sx={{ mt: 0.5, alignItems: 'stretch' }}>
                                        {/* WORKer Type Card */}
                                        <Grid item xs={12} sm={6}>
                                            <Paper
                                                variant="outlined"
                                                sx={{
                                                    p: 1.5,
                                                    height: '100%',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    borderColor: '#e0e0e0',
                                                    borderRadius: '8px',
                                                    backgroundColor: '#fafbfc'
                                                }}
                                            >
                                                {/* Header */}
                                                <Box sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    pb: 1,
                                                    mb: 1,
                                                    borderBottom: '1px solid #ebebeb'
                                                }}>
                                                    <Typography sx={{
                                                        fontSize: '0.95rem',
                                                        fontWeight: 600,
                                                        color: headingBlue
                                                    }}>
                                                        WORKer Type
                                                    </Typography>
                                                    {props?.data?.WORKerType && selectedWORKerTypeDetails?.['label'] && (
                                                        <Button style={{
                                                            ...buttonStyle,
                                                            pointerEvents: 'none',
                                                            backgroundColor: selectedWORKerTypeDetails?.['color'] || headingBlue,
                                                            border: '0px solid',
                                                            fontSize: '0.72rem',
                                                            padding: '0.1rem 0.5rem',
                                                            borderRadius: '4px',
                                                            marginRight: 0
                                                        }}>
                                                            {selectedWORKerTypeDetails?.['label']}
                                                        </Button>
                                                    )}
                                                </Box>

                                                {/* Radio options */}
                                                <Box sx={{
                                                    flex: 1,
                                                    width: '100%',
                                                    '& .MuiFormControl-root': { width: '100%' },
                                                    '& .MuiFormControlLabel-root': { my: 0.1 }
                                                }}>
                                                    <CustomRadioButton
                                                        value={selectedWorkerType}
                                                        list={WORKerTypesList}
                                                        updateFunc={updateSelectWORKerType}
                                                        infoRequired={true}
                                                    />
                                                </Box>
                                            </Paper>
                                        </Grid>

                                        {/* WORKer Cateogary Card */}
                                        <Grid item xs={12} sm={6}>
                                            <Paper
                                                variant="outlined"
                                                sx={{
                                                    p: 1.5,
                                                    height: '100%',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    borderColor: '#e0e0e0',
                                                    borderRadius: '8px',
                                                    backgroundColor: '#fafbfc'
                                                }}
                                            >
                                                {/* Header */}
                                                <Box sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    pb: 1,
                                                    mb: 1,
                                                    borderBottom: '1px solid #ebebeb'
                                                }}>
                                                    <Typography sx={{
                                                        fontSize: '0.95rem',
                                                        fontWeight: 600,
                                                        color: headingBlue
                                                    }}>
                                                        WORKer Cateogary
                                                    </Typography>
                                                    {Boolean(getCategoryValue(props?.data)) && (
                                                        <Button style={{
                                                            ...buttonStyle,
                                                            pointerEvents: 'none',
                                                            backgroundColor: headingBlue,
                                                            border: '0px solid',
                                                            fontSize: '0.72rem',
                                                            padding: '0.1rem 0.5rem',
                                                            borderRadius: '4px',
                                                            marginRight: 0
                                                        }}>
                                                            {getCategoryValue(props?.data) === 'committed' ? 'Committed WORKers' : 'Supported WORKer'}
                                                        </Button>
                                                    )}
                                                </Box>

                                                {/* Radio options */}
                                                <Box sx={{
                                                    flex: 1,
                                                    width: '100%',
                                                    '& .MuiFormControl-root': { width: '100%' },
                                                    '& .MuiFormControlLabel-root': { my: 0.25 }
                                                }}>
                                                    <CustomRadioButton
                                                        value={selectedWORKerCategory || ''}
                                                        list={WORKerCategoryList}
                                                        updateFunc={updateSelectWORKerCategory}
                                                        infoRequired={false}
                                                    />
                                                </Box>
                                            </Paper>
                                        </Grid>
                                    </Grid>

                                    {/* Action Buttons */}
                                    <Box sx={{
                                        display: 'flex',
                                        justifyContent: { xs: 'space-between', sm: 'flex-end' },
                                        gap: 1.5,
                                        marginTop: { xs: '1rem', sm: '1.25rem' },
                                        paddingBottom: '0.5rem'
                                    }}>
                                        <Button
                                            style={{
                                                ...buttonStyle,
                                                padding: '0.35rem 1.25rem',
                                                backgroundColor: maroon,
                                                border: `1px solid ${maroon}`,
                                                width: isMobile ? '48%' : 'auto',
                                                borderRadius: '4px'
                                            }}
                                            onClick={() => props?.setWORKerSettingDialogStatus(false, false)}
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            style={{
                                                ...buttonStyle,
                                                padding: '0.35rem 1.25rem',
                                                width: isMobile ? '48%' : 'auto',
                                                borderRadius: '4px'
                                            }}
                                            onClick={() => updateProfileType()}
                                        >
                                            UPDATE
                                        </Button>
                                    </Box>
                                </Box>}

                            {selectedModule === 'stateHead' &&
                                <>
                                    {
                                        isStateHead && !addStateClickedStatus ?
                                            <>
                                                <Box style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', padding: '0.5rem 0.3rem 0.3rem 0.3rem' }}>
                                                    <Checkbox checked={isStateHead} style={{ padding: 0 }}></Checkbox>
                                                    <Typography style={{ fontSize: '0.9rem' }}>State Head</Typography>
                                                </Box>
                                                {loader && <Loader></Loader>}
                                                <Paper style={{ height: '25vh', padding: '0.5rem 0.3rem 0.3rem 0.5rem' }}>
                                                    <Box style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', padding: "0rem 2rem 0rem 2rem" }}>
                                                        <img
                                                            src={require("../../../assets/images/add.png")}
                                                            alt="add icon"
                                                            style={{ width: "1rem", height: "1rem", marginRight: "0.5rem" }}
                                                            onClick={() => {
                                                                setAddStateClickedStatus(() => true)
                                                            }}
                                                        ></img>
                                                    </Box>
                                                    <Box style={{ height: '21vh', overflow: 'auto' }}>
                                                        {stateHeadDistricts?.length > 0 ?
                                                            stateHeadDistricts?.map((ele) => (
                                                                chipComponent(ele)
                                                            )) :
                                                            <Typography style={{ padding: '1rem 0.5rem 1rem 0.5rem', color: headingBlue }}>
                                                                No District is assigned.
                                                            </Typography>
                                                        }
                                                    </Box>
                                                </Paper>

                                            </> :
                                            <>
                                                {!isStateHead &&
                                                    <>
                                                        <Typography style={{ padding: '1rem 0.5rem 1rem 0.5rem', color: headingBlue }}>
                                                            Worker is not assigned as State Head.
                                                        </Typography>
                                                    </>
                                                }
                                            </>
                                    }

                                </>

                            }

                            {selectedModule === 'districtHead' &&
                                <>
                                    {
                                        <>
                                            {/* <Box style={{display: 'flex', flexDirection: 'row', alignItems: 'center', padding: '0.5rem 0.3rem 0.3rem 0.3rem'}}>
                                        <Checkbox checked={isDistrictHead} style={{padding: 0}}></Checkbox>
                                        <Typography style={{fontSize: '0.9rem'}}>District Head</Typography>
                                    </Box> */}
                                            {loader && <Loader></Loader>}
                                            {!addDistrictClickedStatus && <Paper style={{ height: '25vh', padding: '0.5rem 0.3rem 0.3rem 0.5rem', marginTop: '1rem' }}>
                                                {!isDistrictHead ?
                                                    <>
                                                        <Typography style={{ padding: '1rem 0.5rem 1rem 0.5rem', color: headingBlue }}>
                                                            This WORKer is not a District Head. Click on the button to make District Head.
                                                        </Typography>
                                                        <Box style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', padding: "0rem 2rem 0rem 2rem" }}>
                                                            <Button
                                                                // src={require("../../../assets/images/add.png")}
                                                                alt="add icon"
                                                                style={{ ...buttonStyle }}
                                                                // style={{ width: "1rem", height: "1rem", marginRight: "0.5rem" }}
                                                                onClick={() => {
                                                                    setIsDistrictHead(() => true)
                                                                    setAddDistrictClickedStatus(() => true)
                                                                }}
                                                            >Make District Head</Button>
                                                        </Box>
                                                    </> :
                                                    <Box style={{ height: '21vh', overflow: 'auto' }}>
                                                        {districtHeadDistricts?.length > 0 ?
                                                            districtHeadDistricts?.map((ele) => (
                                                                chipComponent(ele)
                                                            )) :
                                                            <>
                                                                <Typography style={{ color: headingBlue }}>No District is assigned to head. Click on + icon to add the District.</Typography>
                                                            </>
                                                        }
                                                        <Box style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', padding: "0rem 2rem 0rem 2rem" }}>
                                                            <img
                                                                src={require("../../../assets/images/add.png")}
                                                                alt="add icon"
                                                                style={{ width: "1rem", height: "1rem", marginRight: "0.5rem" }}
                                                                onClick={() => {
                                                                    setAddDistrictClickedStatus(() => true)
                                                                }}
                                                            ></img>
                                                        </Box>
                                                    </Box>}
                                            </Paper>}

                                        </>
                                        // :
                                        // <>
                                        /* {!isDistrictHead && 
                                            <>
                                                <Typography style={{padding: '1rem 0.5rem 1rem 0.5rem', color: headingBlue}}>
                                                Worker is not assigned as District Head.
                                                </Typography>
                                            </>
                                        } */
                                        // </>
                                    }
                                </>

                            }

                            {selectedModule === 'account' &&
                                <>
                                    {loader && <Loader></Loader>}
                                    {(localStorage.getItem('designation') === 'admin' || localStorage.getItem('isStateHead')) && isAccountExists ?
                                        <>
                                            <Typography style={{ padding: '1.5rem 0.3rem 0.5rem 0.3rem', color: headingBlue }}>
                                                The head account is ready. Login credentials have been sent to the email.
                                            </Typography>
                                            <Box style={{ display: 'flex', justifyContent: 'flex-end', padding: '0.5rem' }}>
                                            </Box>
                                        </> :
                                        <>
                                            {(localStorage.getItem('designation') === 'admin' || localStorage.getItem('isStateHead')) && (props?.data?.isStateHead || props?.data?.isDistrictHead) ?
                                                <>
                                                    <Typography style={{ padding: '0.5rem 0.3rem 0.5rem 0.3rem', color: headingBlue }}>
                                                        Dashboard account does not exists.
                                                    </Typography>
                                                    <Paper style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', padding: '1.5rem 0.5rem 1rem 0.5rem', marginTop: '0.5rem' }}>
                                                        <CustomTextField placeHolder="Enter Head's email" width='15rem' value={enteredEmail} setFunc={(value) => { setEnteredEmail(value) }}></CustomTextField>
                                                        <Button style={{ ...buttonStyle, marginTop: '1rem', padding: '0.2rem 0.5rem 0.2rem 0.5rem' }}
                                                            onClick={() => handleCreateAcc()}
                                                        >Create Account</Button>
                                                        <Typography style={{ padding: '1rem', color: red }}>{mailError}</Typography>
                                                    </Paper>
                                                </>
                                                :
                                                <>
                                                    <Typography style={{ padding: '0.5rem 0.3rem 0.5rem 0.3rem', color: headingBlue }}>
                                                        Dashboard account is not required for Members.
                                                    </Typography>
                                                </>
                                            }
                                        </>
                                    }

                                    {!(props?.data?.isStateHead || props?.data?.isDistrictHead) &&
                                        <>
                                            <Typography style={{ padding: '0.5rem 0.3rem 0.5rem 0.3rem', color: headingBlue }}>
                                                Portal Account
                                            </Typography>
                                            <Box
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'flex-end',
                                                    padding: '0.5rem',
                                                }}
                                            >
                                                <Button
                                                    variant="contained"
                                                    style={{ ...buttonStyle, fontSize: '0.9rem', marginTop: '0.5rem', padding: '0.1rem 0.4rem 0.1rem 0.4rem' }}
                                                    onClick={() => {
                                                        updateLeaderDialogStatus(
                                                            true,
                                                            'Are you sure you want to reset user account?',
                                                            props?.data?.contactNumber || "",
                                                            false,
                                                            false
                                                        )
                                                        setOperation('delete')
                                                    }

                                                    }
                                                >
                                                    Reset Account
                                                </Button>
                                            </Box>
                                        </>}

                                </>

                            }

                            {selectedModule === 'membershipCard' &&
                                <>
                                    {loader && <Loader></Loader>}
                                    <Paper style={{ padding: '1.5rem', marginTop: '1rem', borderRadius: '8px' }}>
                                        <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Box>
                                                <Typography style={{ fontSize: '1.1rem', color: headingBlue, fontWeight: 600 }}>Membership Card</Typography>
                                                <Typography style={{ fontSize: '0.85rem', color: darkGrey, marginTop: '0.2rem' }}>
                                                    {memCardStatus ? 'Membership card is ready to view.' : 'Membership card is not yet generated.'}
                                                </Typography>
                                            </Box>
                                            <Button
                                                style={{ ...buttonStyle, fontSize: '0.9rem', padding: '0.3rem 1.5rem', minWidth: '100px' }}
                                                onClick={() => memCardStatus ? setMemCardDialogStatus(true) : setUpdateWORKerDetailsDialogStatus(true)}
                                            >
                                                {memCardStatus ? 'View' : 'Generate'}
                                            </Button>
                                        </Box>

                                        <Divider style={{ margin: '1rem 0' }} />

                                        <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Box>
                                                <Typography style={{ fontSize: '1.1rem', color: headingBlue, fontWeight: 600 }}>Membership Form</Typography>
                                                <Typography style={{ fontSize: '0.85rem', color: darkGrey, marginTop: '0.2rem' }}>
                                                    {isRegFormExists ? 'View the submitted registration form details.' : 'Membership form is not available.'}
                                                </Typography>
                                            </Box>
                                            <Button
                                                disabled={!isRegFormExists}
                                                style={!isRegFormExists ? { ...buttonStyle, fontSize: '0.9rem', padding: '0.3rem 1.5rem', minWidth: '100px', opacity: 0.6, cursor: 'not-allowed' } : { ...buttonStyle, fontSize: '0.9rem', padding: '0.3rem 1.5rem', minWidth: '100px' }}
                                                onClick={() => setRegFormDialogStatus(true)}
                                            >
                                                View
                                            </Button>
                                        </Box>
                                    </Paper>
                                </>

                            }

                            {selectedModule === 'stateHead' && addStateClickedStatus &&
                                <>
                                    <Paper style={{ marginTop: '0.3rem', height: '32vh', padding: '0.3rem 0.3rem 0.5rem 0.3rem' }}>
                                        {loader && <Loader></Loader>}
                                        <Stack direction="row" spacing={1} flexWrap="wrap"
                                            style={{
                                                display: 'flex', flexDirection: 'row', padding: '0.1rem 0rem 0.3rem 0rem', height: '14vh',
                                                overflowY: 'auto',
                                                "&::-webkit-scrollbar": {
                                                    display: 'none'
                                                },
                                                scrollbarWidth: "none",
                                            }}
                                        >
                                            {
                                                selectedStatesToAdd?.map((district) => (
                                                    <Box style={{ padding: '0.1rem' }}>
                                                        <Chip
                                                            label={`${district.district}, ${district.state}`}
                                                            onDelete={() => deleteDistrictFromAddition({ district: district?.district, state: district?.state })}
                                                        >

                                                        </Chip>
                                                    </Box>
                                                ))
                                            }
                                        </Stack>
                                        <Grid container spacing={1} style={{ marginTop: '0.3rem' }}>
                                            <Grid item xs={5} sm={5}>
                                                <CustomDropDown placeHolder='State' list={stateHeadlessStates} value={selectedStateHeadlessState} setFunc={(value) => { setSelectedStateHeadlessState(value) }} regular={true} width='11rem'></CustomDropDown>
                                            </Grid>
                                            <Grid item xs={5} sm={5}>
                                                <CustomDropDown placeHolder='District' list={stateHeadlessDistricts} value={selectedStateHeadlessDistrict} setFunc={(value) => { setSelectedStateHeadlessDistrict(value) }} regular={true} width='11rem'></CustomDropDown>
                                            </Grid>
                                            <Grid item xs={2} sm={2}>
                                                <Button style={{ ...buttonStyle, padding: '0.1rem 0.2rem 0.1rem 0.2rem' }}
                                                    onClick={() => {
                                                        var array = [...selectedStatesToAdd]
                                                        array.push({ state: selectedStateHeadlessState, district: selectedStateHeadlessDistrict })
                                                        handleAddDistrictToAdd(array)
                                                    }}
                                                > Add</Button>

                                            </Grid>
                                        </Grid>
                                        <Box style={{ display: 'flex', justifyContent: 'center', padding: '1rem 0.1rem 0.75rem 0.1rem' }}>
                                            <Button style={{ ...buttonStyle, padding: '0.1rem 0.5rem 0.1rem 0.5rem', fontSize: '0.8rem' }}
                                                onClick={() => {
                                                    setAddStateClickedStatus(false)
                                                }}
                                            > Cancel</Button>
                                            <Button style={{ ...buttonStyle, padding: '0.1rem 0.5rem 0.1rem 0.5rem', fontSize: '0.8rem' }}
                                                onClick={() => { handleAssignDistrictsToStateHead() }}
                                            > Assign</Button>
                                        </Box>
                                    </Paper>

                                </>
                            }

                            {selectedModule === 'districtHead' && addDistrictClickedStatus &&
                                <>
                                    <Paper style={{ marginTop: '0.3rem', height: '32vh', padding: '0.3rem 0.3rem 0.5rem 0.3rem' }}>
                                        {loader && <Loader></Loader>}
                                        <Stack direction="row" spacing={1} flexWrap="wrap"
                                            style={{
                                                display: 'flex', flexDirection: 'row', padding: '0.1rem 0rem 0.3rem 0rem', height: '14vh',
                                                overflowY: 'auto',
                                                "&::-webkit-scrollbar": {
                                                    display: 'none'
                                                },
                                                scrollbarWidth: "none",
                                            }}
                                        >
                                            {
                                                selectedDistrictsToAdd?.map((district) => (
                                                    <Box style={{ padding: '0.1rem' }}>
                                                        <Chip
                                                            label={`${district.district}, ${district.state}`}
                                                            onDelete={() => deleteHeadDistrictFromAddition({ district: district?.district, state: district?.state })}
                                                        >
                                                        </Chip>
                                                    </Box>
                                                ))
                                            }
                                        </Stack>
                                        <Grid container spacing={1} style={{ marginTop: '0.3rem' }}>
                                            <Grid item xs={4} sm={4}>
                                                <CustomDropDown placeHolder='State' list={districtHeadlessStates} value={selectedDistrictHeadlessState} setFunc={(value) => { setSelectedDistrictHeadlessState(value) }} regular={true} width='13rem'></CustomDropDown>
                                            </Grid>
                                            <Grid item xs={4} sm={4}>
                                                <CustomDropDown placeHolder='District' list={districtHeadlessDistricts} value={selectedDistrictHeadlessDistrict} setFunc={(value) => { setSelectedDistrictHeadlessDistrict(value) }} regular={true} width='13rem'></CustomDropDown>
                                            </Grid>
                                            <Grid item xs={2} sm={2}>
                                                <Button style={{ ...buttonStyle, padding: '0.1rem 0.2rem 0.1rem 0.2rem' }}
                                                    onClick={() => {
                                                        var array = [...selectedDistrictsToAdd]
                                                        array.push({ state: selectedDistrictHeadlessState, district: selectedDistrictHeadlessDistrict })
                                                        handleAddDistrictToHead(array)
                                                    }}
                                                > Add</Button>

                                            </Grid>
                                        </Grid>
                                        <Box style={{ display: 'flex', justifyContent: 'center', padding: '1rem 0.1rem 0.75rem 0.1rem' }}>
                                            <Button style={{ ...buttonStyle, padding: '0.1rem 0.5rem 0.1rem 0.5rem', fontSize: '0.8rem' }}
                                                onClick={() => {
                                                    if (!props?.data?.isDistrictHead) {
                                                        setIsDistrictHead(() => false)
                                                    }
                                                    setAddDistrictClickedStatus(false)
                                                }}
                                            > Cancel</Button>
                                            <Button style={{ ...buttonStyle, padding: '0.1rem 0.5rem 0.1rem 0.5rem', fontSize: '0.8rem' }}
                                                onClick={() => { handleAssignDistrictToDistrictHead() }}
                                            > Assign</Button>
                                        </Box>
                                    </Paper>

                                </>
                            }

                            {selectedModule === 'contrAreas' &&
                                <ConfigWORKerContrFields contactNumber={props?.data?.contactNumber} update={true}></ConfigWORKerContrFields>
                            }
                        </Grid>

                    </Grid>

                    <ConfirmationDialogBox leaderDialogStatus={leaderDialogStatus} updateLeaderDialogStatus={updateLeaderDialogStatus} confirmationMsg={confirmationMessage} contactNumber={leaderContactNumber} isLeader={leaderIsLeader} isNoActionDialog={isNoActionDialog} operation={operation}></ConfirmationDialogBox>

                </DialogContent>

            </Dialog>

            <Memcard memcardDialogStatus={memcardDialogStatus}
                updatememCardDialogStatus={() => {
                    setMemCardDialogStatus(!memcardDialogStatus)
                    // setUserIconStatus(() => false)
                }}
                name={name}
                chapterCode={chapterCode}
                id={id}
                obligation={obligation}
                photoStatus={photoStatus}
                contactNumber={props?.data?.contactNumber}
            ></Memcard>

            <UpdateWORKerDetails wORKerDetailsDialogStatus={updateWORKerDetailsDialogStatus} updateWORKerDetailsDialogStatusFunc={() => {
                setUpdateWORKerDetailsDialogStatus(!updateWORKerDetailsDialogStatus)
                setRefreshCardSec(!refreshCardSec)
                // setUserIconStatus( () => false)
            }}
                chapterCode={chapterCode}
                gender={gender}
                id={id}
                contactNumber={props?.data?.contactNumber}
            ></UpdateWORKerDetails>

            <RegistrationInviteDetails
                dialogStatus={regFormDialogStatus}
                updateDialogStatus={(status, refresh) => {
                    setRegFormDialogStatus(status);
                }}
                data={regFormData}
            />

            {/* <AddDistrictDialog dialogStatus={addStateDialogStatus} updateDialogStatus={updateAddStateDialogStatus}>
    </AddDistrictDialog> */}
        </>
    )
}


const chipComponent = ((data) => {
    return (
        <>
            <Box style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', flexDirection: 'row' }}>
                <Grid container spacing={1} style={{}}>
                    <Grid item xs={4} sm={4}>
                        <Typography>{data.state}</Typography>
                    </Grid>
                    <Grid item xs={4} sm={4}>
                        <Typography>{data.district}</Typography>
                    </Grid>
                    {/* <Grid item xs= {1} sm={1}>
                        <img src= {require('../../../assets/images/delete_icons.png')} 
                            style={{width: '1rem', height: '1rem'}}
                        ></img>
                    </Grid> */}

                </Grid>
            </Box>

        </>
    )
})


export default WORKerSettingDialog